"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoFilter = void 0;
/**
 * The VideoFilter model represents the possible video filters that allow blurring or changing the local participant's background. The video filters are available only for the Dolby.io Communications SDK for Desktop users.
 */
var VideoFilter;
(function (VideoFilter) {
    /**
     * Disables the applied video filter. This setting does not disable [video denoising](doc:js-client-sdk-model-videofilteroptions#videodenoise); you can still use [video denoising](doc:js-client-sdk-model-videofilteroptions#videodenoise) when VideoFilter is set to `None`.
     *
     * Example: VoxeetSDK.videoFilters.setFilter(VideoFilter.None)
     */
    VideoFilter["None"] = "none";
    /**
     * Blurs the local participant's background.
     *
     * Example: VoxeetSDK.videoFilters.setFilter(VideoFilter.Bokeh)
     */
    VideoFilter["Bokeh"] = "bokeh";
    /**
     * Replaces the local participant's background with the selected static image.
     *
     * Example: VoxeetSDK.videoFilters.setFilter(VideoFilter.StaticImage, {imageFile: fileObject})
     */
    VideoFilter["StaticImage"] = "staticimage";
})(VideoFilter = exports.VideoFilter || (exports.VideoFilter = {}));
